import React, {useContext, useState} from 'react';
import { Button, TextField } from '@material-ui/core'
import DatePicker from "react-datepicker/es";
import "react-datepicker/dist/react-datepicker.css";
import {AppContext} from "../AppContext";
import {MessageContext} from "../MessageContext";
import {useHistory} from "react-router-dom";
import useFormState from './useFormState';
import moment from 'moment';


export default function CreateEvent() {

    const [name, setName] = useFormState("")
    const [description, setDescription] = useFormState("")
    const [price, setPrice] = useFormState(0)
    const [startDate, setStartDate] = useState(new Date())
    const [finishDate, setFinishDate] = useState(new Date())
    const [timezone, setTimezone] = useState('eastern')
    const [venue, setVenue] = useState('mainVenue')
    const [venueData, setVenueData] = useState('')

    const context = useContext(AppContext)
    const messageContext = useContext(MessageContext)
    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault()

        if (name === "") {
            messageContext.showErrorMessage("Please name the event")
        } else if (!moment(startDate).isBefore(moment(finishDate))){
            messageContext.showErrorMessage("End date has to be later than the start date")
        } else {
            fetch(`${process.env.REACT_APP_API_CALL}/events`, {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    name: name,
                    description: description,
                    host_user: context.currentUser.id,
                    price: price,
                    start_time: startDate,
                    finish_time: finishDate,
                    timezone: timezone,
                    venue: venue,
                    venueData: venueData
                })
            })
                .then(response => response.json())
                .then(response => {
                    if (response.errors) {
                        messageContext.showErrorMessage(response.errors)
                    } else {
                        messageContext.showSuccessMessage("Event has been created")
                        history.push("/")
                    }
                })
        }
    }



    return (
        <div>

            <form onSubmit={handleSubmit} className="create-event-body">

                <div id="create-event-left">
                    <div className="new-event-field">
                        <p>Event Name</p>
                        <TextField id="name" name="name" value={name} onChange={setName}/>
                    </div>

                    <div className="new-event-field">
                        <p>Event Description</p>
                        <TextField id="description" name="description" multiline={true} value={description} onChange={setDescription}/>
                    </div>

                    <div className="new-event-field">
                        <p>Price</p>
                        <TextField id="price" name="price" value={price} onChange={setPrice}/>
                    </div>

                    <div className="new-event-field">
                        <p>Event Venue</p>
                        <select value={venue} onChange={(event) => setVenue(event.target.value)}>
                            <option value="MainVenue">MainVenue</option>
                            <option value="PartyVenue">PartyVenue</option>
                        </select>
                    </div>

                    <div className="new-event-field">
                        <p>Enter Venue Data</p>
                        <TextField id="venue-data" name="venue-data" multiline={true} value={venueData} onChange={(event) => setVenueData(event.target.value)}/>
                    </div>

                    <br/>
                        <Button onClick={() => {history.push("/")}} variant="contained" color="secondary">Cancel</Button>
                        <Button type="submit" id="create-event-button" variant="contained" color="primary">Create Event</Button>
                </div>


                <div id="create-event-right">
                    <div className="new-event-field">
                        <p>Start Date and Time</p>
                        <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} showTimeSelect timeFormat="HH:mm" timeIntervals={15} timeCaption="time" dateFormat="MMMM d, yyyy h:mm aa" />
                    </div>


                    <div className="new-event-field">
                        <p>Finish Date and Time</p>
                        <DatePicker selected={finishDate} onChange={(date) => setFinishDate(date)} showTimeSelect timeFormat="HH:mm" timeIntervals={15} timeCaption="time" dateFormat="MMMM d, yyyy h:mm aa" />
                    </div>

                    <div className="new-event-field">
                        <p>Timezone of the event</p>
                        <select value={timezone} onChange={(event) => setTimezone(event.target.value)}>
                            <option value="est">Eastern</option>
                            <option value="cst">Central</option>
                            <option value="mst">Mountain</option>
                            <option value="pst">Pacific</option>
                        </select>

                    </div>
                </div>

            </form>
        </div>
    )

}
